import React from "react";

import { useTranslate } from "localization";
import { Icon } from "minimum-ui/core";
import { color } from "minimum-ui/tokens";
import styled from "styled-components";
import { H4M } from "typography/headers";
import { Filter } from "ui/forms";

import { useReportingYearsQuery } from "API";

import useFilterParam from "./useFilterParam";

const ReportingYear: React.FC = () => {
  const { translate } = useTranslate();
  const title = translate("reportingYear");

  const {
    data = [],
    isSuccess,
    isError,
  } = useReportingYearsQuery(void 0, {
    selectFromResult: (result) => ({
      ...result,
      data: result.data?.map((item) => ({
        value: item.id,
        label: item.label ?? "Unknown",
        startDate: item.startDate ?? "Unknown",
        endDate: item.endDate ?? "Unknown",
      })),
    }),
  });

  const [selected, setSelected] = useFilterParam("reporting_year", data, {
    defaultToFirst: true,
    ready: isSuccess || isError,
  });
  const selectedReportingYear = data.find((item) => item.value === selected);

  return (
    <ReportingYearContainer>
      <ReportingYearLabel>
        <Icon icon="calendar" size="2xs" />
        <Title>{title}:</Title>
      </ReportingYearLabel>
      <ReportingYearFilter
        items={{ options: data }}
        title={title}
        label={selectedReportingYear?.label || ""}
        onChange={setSelected}
        value={selected ?? ""}
        disabled={!isSuccess || !selected}
        selected={!!selected}
        translate={translate}
      />
    </ReportingYearContainer>
  );
};

const ReportingYearContainer = styled.div`
  display: inline-flex;
  align-items: center;
  height: 32px;
  border-radius: 4px;
`;

const ReportingYearLabel = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 12px;
  height: 32px;
  border-radius: 4px 0px 0px 4px;
  border-width: 1px 0px 1px 1px;
  border-style: solid;
  border-color: ${color.neutral[200]};
`;

const Title = styled(H4M)`
  padding-left: 4px;
  color: ${color.neutral[400]};
`;

const ReportingYearFilter = styled(Filter)`
  height: 32px;
  border-radius: 0px 4px 4px 0px;
  background-color: ${color.neutral[100]};
  border: 1px solid ${color.neutral[200]};

  &:hover {
    background-color: ${color.neutral[100]};
    border-color: ${color.neutral[300]};
  }
`;

export default ReportingYear;
